SessionTimeout:
  description: 無効なアクセストークンが入力されたか、当該アクセストークンの有効期限が切れている場合。
  value: {
    "success": false,
    "all": "Session is timeout",
    "result_code": "01"
  }

DoNotHavePermission:
  description: アクセストークン発行の権限がない場合。
  value: {
    "success": false,
    "all": "You do not have permission",
    "result_code": "00"
  }

InputValueIsInvalid:
  description: 無効な値が入力された場合。
  value: {
    "success": false,
    "all": "Input value is invalid.",
    "result_code": "00"
  }

DoNotHavePermissionfolderd:
  description: フォルダ削除の権限がない場合。
  value: {
    "success": false,
    "all": "You do not have permission",
    "result_code": "00"
  }

DoNotHavePermissionfolderm:
  description: フォルダ移動の権限がない場合。
  value: {
    "success": false,
    "all": "You do not have permission",
    "result_code": "00"
  }

DoNotHavePermissionfolderi:
  description: フォルダ容量情報取得の権限がない場合。
  value: {
    "success": false,
    "all": "You do not have permission",
    "result_code": "00"
  }

DoNotHavePermissionfileu:
  description: ファイルアップロードの権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfilef:
  description: ファイル名変更の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfiledown:
  description: ファイルダウンロードの権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfilem:
  description: ファイル移動の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfiledel:
  description: ファイル削除の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfiles:
  description: ファイル検索の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfilel:
  description: リンク作成の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

DoNotHavePermissionfilev:
  description: ファイルビューアー作成の権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "00"
  }

PreviewNotSupportFileType:
  description: プレビューに対応していないファイル形式です。
  value: {
    "success": false,
    "all": "This file does not support Preview.",
    "result_code": "00"
  }

DoNotHavePermissionFileCompress:
  description: 複数ファイルのダウンロードの権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "4001"
  }

DoNotHavePermissionThumbnail:
  description: 複数ファイルのサムネイル画像の取得権限がない場合。
  value: {
    "success": false,
    "all": "You have no authority",
    "result_code": "4001"
  }

DoNotHavePermissionsso:
  description: アクセスキー取得の権限がない場合。
  value: {
    "success": false,
    "all": "You do not have permission",
    "result_code": "00"
  }

FileOrDirectoryNotExists:
  description: 対象のファイルまたはフォルダが存在しない場合。
  value: {
    "success": false,
    "all": "File or folder doesn’t exist",
    "result_code": "00"
  }

FolderOrDirectoryNotExists:
  description: 対象のフォルダが存在しない場合。
  value: {
    "success": false,
    "all": "File or folder doesn’t exist",
    "result_code": "00"
  }

FileOrFolderNotExists:
  description: 対象のファイルまたはフォルダが存在しない場合。
  value: {
    "success": false,
    "all": "File or folder doesn’t exist",
    "result_code": "00"
  }

FoldernotExists:
  description: 入力したフォルダノードが存在しない場合。
  value: {
    "success": false,
    "all": "Directory not found",
    "result_code": "00"
  }

UnknownError:
  description: 予期しないエラーが発生した場合。
  value: {
    "success": false,
    "all": "Unknown error occurred. Please try again later",
    "result_code": "00"
  }

SameDirectoryExists:
  description: 移動先に同じ名前のフォルダが存在している場合。
  value: {
    "success": false,
    "all": "You can not copy, move or restore as the same folder name",
    "result_code": "00"
  }

FileNameAlreadyExists:
  description: 入力されたファイル名がすでに存在している場合。
  value: {
    "success": false,
    "all": "File name already exists",
    "result_code": "00"
  }

DeleteFailedIncludedLockFile:
  description: 対象のフォルダにロックされたファイルが保存されている場合。
  value: {
    "success": false,
    "all": "You cannot delete this folder because it may contain locked files",
    "result_code": "00"
  }

InvalidInput:
  description: 無効な値が入力された場合。
  value: {
    "success": false,
    "all": "Input value is invalid",
    "result_code": "00"
  }

internalservererror:
  description: 予期しないエラーが発生した場合。
  value: {
    "success": false,
    "all": "Unknown error occurred. Please try again later",
    "result_code": "00"
  }

Webhooknotexists:
  description: Webhookが作成されていない場合。
  value: {
    "success": false,
    "all": "Webhook does not exist",
    "result_code": "00"
  }

InvalidInputCreateFolder:
  description: 入力されたアカウント情報が正しくない場合。
  value: {
    "success": false,
    "all": "Input value is invalid",
    "result_code": "00"
  }

SharedBoxIsDisable:
  description: 照会対象のフォルダが存在しない場合。
  value: {
    "success": false,
    "all": "Shared box is disable",
    "result_code": "00"
  }

FolderNameLengthExceeded:
  description: フォルダ名に190個以上の文字数が入力された場合。
  value: {
    "success": false,
    "all": "Folder name must be smaller than 190 characters",
    "result_code": "00"
  }

FolderAlreadyExist:
  description: 入力されたフォルダ名がすでに存在している場合。
  value: {
    "success": false,
    "all": "Folder name already exists",
    "result_code": "4009",
    "existing_folder": {
      "dir_seq": 12345,
      "node": "1{2011XEA"
    }
  }

NoAuth:
  description: 権限がない作業を行ったとき。
  value: {
    "success": false,
    "all": "You have no authority.",
    "result_code": "00"
  }

NoAccount:
  description: 入力されたアカウント情報が正しくない場合。
  value: {
    "success": false,
    "result": "Invalid login information",
    "message": "No Account."
  }

unauthorized:
  description: 入力したアカウントが存在しないか正しくない場合。
  value: {
    "success": false,
    "result": "",
    "message": "No Account"
  }

duplicatedlogin:
  description: 他の場所からの接続が発生したため、既存のログインセッションが終了した場合。
  value: {
    "success": false,
    "result": "",
    "message": "It is logged out due to another login from another place"
  }

expiredtoken:
  description: アクセストークンの有効期限が切れている場合。
  value: {
    "success": false,
    "result": "",
    "message": "This login has been terminated due to the expiration date on policy. Please login again"
  }

Webhookunavailablenode:
  description: 利用できないノードが選択された場合。
  value: {
    "success": false,
    "result": "",
    "message": "This node can not be used on Webhook"
  }

Hasnoauthority:
  description: Webhook作成の権限がない場合。
  value: {
    "success": false,
    "result": "",
    "message": "You have no authority"
  }

Webhookunavailablenodev:
  description: 利用できないノードを照会した場合。
  value: {
    "success": false,
    "result": "",
    "message": "This node can not be used on Webhook"
  }

Hasnoauthorityv:
  description: Webhook照会の権限がない場合。
  value: {
    "success": false,
    "result": "",
    "message": "You have no authority"
  }

Webhookunavailablenoded:
  description: 利用できないノードを削除しようとした場合。
  value: {
    "success": false,
    "result": "",
    "message": "This node can not be used on Webhook"
  }

Hasnoauthorityd:
  description: Webhook削除の権限がない場合。
  value: {
    "success": false,
    "result": "",
    "message": "You have no authority"
  }

Hasnoauthorityf:
  description: Webhook修正の権限がない場合。
  value: {
    "success": false,
    "result": "",
    "message": "You have no authority"
  }

NoAccountWithClassName:
  description: 無効なauth-codeを入力したとき。
  value: {
    "success": false,
    "message": {
      "classname": "Exception",
      "message": "No Account."
    }
  }

InvalidCompanySeq:
  description: 無効なcompany_seqを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "Invalid `company_seq`"
  }

InvalidCharacters:
  description: 無効な文字を入力したとき。
  value: {
    "success": false,
    "message": {
      "classname": "Exception",
      "message": "The code field may only contain alpha-numeric characters, underscores, and dashes."
    }
  }

InvalidAdminSeq:
  description: 無効なadmin_seqを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "Invalid `admin_seq`"
  }

InvalidItemCode:
  description: 無効なitem_codeを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "Invalid `item_code`"
  }

InvalidNoticeSeq:
  description: 無効なnotice_seqを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "Invalid `notice_seq`"
  }

InvalidInputValue:
  description: 無効な値を入力したとき。
  value: {
    "success": false,
    "all": "Input value is invalid.",
    "result_code": "00"
  }

InputValueSSO:
  description: IdPのログイン画面表示の権限がない場合。
  value: {
    "success": false,
    "all": "Input value is invalid.",
    "result_code": "00"
  }

Invalidrequest:
  description: 無効な値が入力された場合。
  value: {
    "success": false,
    "all": "Input value is invalid.",
    "result_code": "00"
  }

EmptyCompanyCode:
  description: company_codeを渡さなかった場合。
  value: {
    "success": false,
    "message": {
      "classname": "Exception",
      "message": "`code` Empty."
    }
  }

EmptyCompanySeq:
  description: company_seqを渡さなかった場合。
  value: {
    "success": false,
    "result": "",
    "message": "`company_seq` Empty."
  }

EmptyParameter:
  description: 必須parameterを渡さなかった場合。
  value: {
    "success": false,
    "result": "",
    "message": "Parameter empty"
  }

EmptyField:
  description: 必須フィールド(XXX)を渡さなかった場合。
  value: {
    "success": false,
    "result": "",
    "message": "The XXX field is required."
  }

NoCompanySeq:
  description: 存在しないcompany_seqを入力したとき。
  value: {
    "success": false,
    "message": {
      "classname": "Exception",
      "message": "No results found"
    }
  }

NoRequiredInputValue:
  description: 必要なパラメーターが入力されていない場合。
  value: {
    "success": false,
    "message": {
      "classname": "Exception",
      "message": "There is no required input value."
    }
  }

CompanyCodeAlreadyInUse:
  description: 既に使用したcompany_codeを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "The code is already in use."
  }

NotExistReseller:
  description: 存在しないリセラー名を入力した場合。
  value: {
    "success": true,
    "result": {
      "count": 0,
      "lists": [ ]
    },
    "message": ""
  }

CompanyIDLength:
  description: 6桁未満のIDを入力した場合。
  value: {
    "success": false,
    "result": "",
    "message": "The ID field must be at least 6 characters in length."
  }

FolderExist:
  description: 既に存在するフォルダ名を入力したとき。
  value: {
    "success": false,
    "all": "Folder name already exists.",
    "result_code": "00"
  }

FolderNameExist:
  description: 重複するフォルダ名を入力したとき。
  value: {
    "success": false,
    "all": "Failed to edit the folder name. [Already exists]",
    "result_code": "00"
  }

FoldernotExist:
  description: 入力したフォルダノードが存在しない場合。
  value: {
    "success": false,
    "all": "Directory Not Found",
    "result_code": "00"
  }

FolderAlreadyExists:
  description: 入力したフォルダ名がすでに存在する場合。
  value: {
    "success": false,
    "all": "Folder name already exists",
    "result_code": "4009",
    "existing_folder": {
      "dir_seq": 12345,
      "node": "1{2011XEA"
    }
  }

UserIDExist:
  description: 追加したユーザーIDが既に存在している場合。
  value: {
    "success": false,
    "all": "user id already exists",
    "result_code": "00"
  }

FileOrFolderNotExist:
  description: 対象のファイルまたはフォルダが存在しない場合。
  value: {
    "success": false,
    "all": "File or folder doesn't exist.",
    "result_code": "04"
  }

UserNotFound:
  description: 入力したユーザー識別コードが存在しない場合。
  value: {
    "success": false,
    "all": "user not found",
    "result_code": "00"
  }

GroupNotFound:
  description: 入力したグループ識別コードが存在しない場合。
  value: {
    "success": false,
    "all": "group not found",
    "result_code": "00"
  }

ParentGroupNotFound:
  description: 親グループの識別コードが存在しない場合。
  value: {
    "success": false,
    "all": "parent group not found",
    "result_code": "00"
  }

GroupNameExist:
  description: 入力したグループ名がすでに存在する場合。
  value: {
    "success": false,
    "all": "group name already exists",
    "result_code": "00"
  }

NoMoreGroupsCanBeAdded:
  description: 作成可能な最大グループ数(100個)を超えて追加した場合。
  value: {
    "success": false,
    "all": "No more groups can be added",
    "result_code": "00"
  }

RelationNotFound:
  description: 存在しない関係の場合。
  value: {
    "success": false,
    "all": "relation not found",
    "result_code": "00"
  }

SSOError:
  description: 管理ページでSSO連携が設定されていない場合
  value: {
    "success": false,
    "all": "This company does not provide SSO. Please move to DirectCloud login Page",
    "result_code": "00"
  }

SSOStatusError:
  description: 認証が完了していない場合
  value: {
    "success": false,
    "status": "1",
  }

SSOStatusError1:
  description: 認証が完了していない場合
  value: {
    "success": false,
    "status": "1",
  }

SSOStatusError3:
  description: 無効なアクセストークンが入力されたか、当該アクセストークンの有効期限が切れている場合
  value: {
    "success": false,
    "status": "3",
  }

ExceedingThePermittedSize:
  description: 圧縮前のファイルの合計容量が2GBを超過した場合。
  value: {
    "success": false,
    "all": "The maximum download capacity is %sGB. Please check and try it again.",
    "result_code": "4002"
  }

ExceedingAllowableNumber:
  description: ダウンロード対象のサムネイル画像の数が2000個を超過した場合。
  value: {
    "success": false,
    "all": "The maximum number of downloadable thumbnails is 2,000. Please check and try it again. ",
    "result_code": "4002"
  }
